import type { LightspeedBusinessLocation } from './apiHelpers';

export const formatLocationAddress = (location: LightspeedBusinessLocation) =>
  [location.street1, location.city, location.state, location.country]
    .filter(Boolean)
    .join(', ');
